<div class="wrapper-page-layout">
  <!-- <app-page-header
  [title]="'terms_conditions_view.terms_and_conditions_terms_conditions' | translate"
    [imgPath]="
      '../../../../../../../assets/images/baners/terms-conditions-bg.webp'
    "
></app-page-header> -->
@if (isLoading) {
  <div
    class="w-100 d-flex justify-content-center align-items-center min-h-80vh"
    >
    <mat-spinner [diameter]="60"></mat-spinner>
  </div>
}

@if (!isLoading) {
  <div class="container terms-container mb-4 min">
    <div class="terms-container-header">
      <h1 data-translation-key="terms_and_conditions_terms_conditions">
        {{ 'terms_and_conditions.terms_conditions' | translate }}
      </h1>
      <p class="main-txt">
        <span data-translation-key="terms_and_conditions_consigner_name">{{ 'terms_and_conditions.consigner_name' | translate }}</span>
        <span>{{ ConsignorName }}</span>
      </p>
      <p class="sub-txt">
        <span data-translation-key="terms_and_conditions_last_update">{{ 'terms_and_conditions.last_update' | translate }}</span>
        <span>{{ updatedAt | localDateTime : "dateSlash" }}</span>
      </p>
    </div>
    <hr />
    <div class="terms-container-body">
      @if (!hasMedia) {
        <p [innerHTML]="content"></p>
      }
      @if (hasMedia) {
        <iframe [src]="content | safeUrl" width="100%" height="600px"></iframe>
      }
    </div>
  </div>
}
</div>
